import { Col, Form, Row, Container } from 'react-bootstrap';
import { ApplicationService, StatisticService } from '../../../../Api';
import { useQuery } from '../../../../Utils';
import { CustomButton, JobTitle } from '../../../StyledComponents';
import { LoadingStates } from '../../../Enums'
import { Legals } from '../../../Legals';
import { Field, Formik } from "formik";
import { Preview } from '../../../Preview';
import { LogoImage } from '../../../LogoImage';
import { CustomApplicationData, CustomApplicationDataInterface } from './CustomApplicationData';

// SubForms
import { PrivacyConsentSubForm, Schema as PrivacyConsentSchema } from './subforms/PrivacyConsent';
import { HoneyPotSubForm } from './subforms/HoneyPot';

export const FormComponent = ({ setUploadStatus, jobList, validationSchema, children, logoUrl }) => {
    const query = useQuery();
    const previewMode = query.get("preview") !== null && query.get("preview") === "true";

    const colors = jobList.colors;
    const legalNoticeUrl = jobList.legalNoticeUrl
    const dataSecurityUrl = jobList.dataSecurityUrl
    const listId = jobList.id;
    const getGohiringVariables = () => {
        var url = window.location.href
        var pos = url.indexOf("?pid=");
        if (pos > 0) {
            let vars = url.substring(pos + 5);
            if (vars.length > 0) {
                var pair = vars.split("&it=");
                return pair
            }
        }
        return [];
    }

    const submitForm = (values: CustomApplicationDataInterface) => {
        console.log(values);

        if (previewMode === true) {
            return;
        }

        // ckeck H.o.n.e.y.p.o.t
        if (values.name.length > 0 || values.email.length > 0) return;

        if (!jobList) return;
        let application = values.getApplication(jobList?.jobs[0].tenant, jobList?.jobs[0].id,listId)

        const data = new FormData()
        data.append('application', JSON.stringify(application))
        if (values.cvFile) data.append('cv', values.cvFile, values.cvFile.name)

        data.append('additionalFilesCount', values.additionalFiles == null ? '0' : values.additionalFiles.length.toString())
        if (values.additionalFiles) {
            for (let i = 0; i < values.additionalFiles.length; i++) {
                const element = values.additionalFiles[i];
                data.append('file' + i, element, element.name)
            }
        }

        setUploadStatus(LoadingStates.Pending);
        ApplicationService.postApplication(data).then(result => {
            if (result) {
                setUploadStatus(LoadingStates.Success);
                StatisticService.updateCounter(jobList?.jobs[0].tenant, jobList?.jobs[0].id, "FormApplicationCount").then(result => {
                    console.log("");
                }).catch(() => {
                    console.log("");
                });
            }
            else {
                setUploadStatus(LoadingStates.Fail);
            }
        }).catch(() => {
            setUploadStatus(LoadingStates.Fail);
        });
    }

    const schema = validationSchema.concat(PrivacyConsentSchema);

    const initialValues = new CustomApplicationData();
    const vars = getGohiringVariables();
    if (vars.length > 0) {
        initialValues.pid = vars[0];
        initialValues.it = vars[1];
    };
    
    return (
        <Container fluid>
            <Container style={{ maxWidth: "800px", backgroundColor: "white" }}>
                <Row>
                    <Col md={12} style={{ display: "flex", justifyContent: "right" }}>
                    </Col>
                    <Col md={12}>{
                        <div>
                            <div style={{ paddingTop: "30px" }}>
                                <Row>
                                    <Col style={{ display: "flex", justifyContent: "left" }}>
                                        <LogoImage url={jobList.jobs[0].hiringOrganization?.sameAs} listId={listId} logoUrl={logoUrl} />
                                    </Col>
                                </Row>
                            </div>
                            {jobList.jobs[0] && <JobTitle>
                                {jobList.jobs[0].title}
                                {previewMode && <Preview />}
                            </JobTitle>}
                            <Formik
                                validationSchema={schema}
                                onSubmit={submitForm}
                                initialValues={initialValues}
                            >
                                {({ handleSubmit, errors,}) => (
                                    <Form noValidate onSubmit={handleSubmit}>

                                        {children}

                                        <Field component={PrivacyConsentSubForm} dataSecurityUrl={dataSecurityUrl} />

                                        <Field component={HoneyPotSubForm} />
                                        <div style={{ paddingTop: "30px", display: "flex", justifyContent: "center" }}>
                                            <CustomButton
                                                variant="primary"
                                                type="submit"
                                                colors={colors}
                                            >Bewerbung absenden</CustomButton>
                                        </div>

                                        {/* <div>
                                            {errors && Object.keys(errors).length !== 0 && <small><b>Validierungsfehler zum Debuggen, bitte ignorieren:</b> {JSON.stringify(errors, null, 2)}</small>}
                                        </div> */}

                                        <footer style={{ display: "table", margin: "auto", paddingTop: "20px" }}>
                                            <Legals colors={colors} legalNoticeUrl={legalNoticeUrl} />
                                        </footer>
                                    </Form>
                                )}
                            </Formik>
                        </div>}
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
